import clinicalClaimsImg from 'assets/images/landingPages/skincare/skincare-lp-clinical-claims.jpg';

export const clinicalClaimsContent = {
  video: {
    poster: clinicalClaimsImg,
    videoSrc: 'skincare-lp-clinical-claims-2',
    alt: 'Woman holding bottle of Prose custom cleanser',
  },
  title: 'Clinically tested and proven effective in 4 weeks',
  numbers: [
    {
      key: 0,
      displayOnMobile: true,
      number: 95,
      numberLabel: (
        <>
          said their skin felt <b>soft</b> after using their cleanser¹
        </>
      ),
    },
    {
      key: 1,
      number: 91,
      numberLabel: (
        <>
          say skin was <b>clear</b> after using their cleanser¹
        </>
      ),
    },
    {
      key: 2,
      number: 91,
      displayOnMobile: true,
      numberLabel: (
        <>
          say skin felt <b>firmer</b> after using their serum²
        </>
      ),
    },
    {
      key: 3,
      number: 82,
      numberLabel: (
        <>
          say <b>wrinkles</b> looked reduced after using their serum²
        </>
      ),
    },
    {
      key: 4,
      number: 92,
      displayOnMobile: true,
      numberLabel: (
        <>
          say their skin looks <b>healthy</b> after using their moisturizer³
        </>
      ),
    },

    {
      key: 5,
      number: 91,
      numberLabel: (
        <>
          say their skin is <b>glowy</b> after using their moisturizer³
        </>
      ),
    },
  ],
  sources: [
    <>
      <b>Clinically tested and shown effective in 4 weeks:</b>
      <br />
      <br />
    </>,
    <>
      (1) Based on a 4-week clinical study of 22 subjects with sensitive skin aged from 18 to 65
      years old who tested Prose Gel Cleanser texture twice a day.
      <br />
      <br />
    </>,
    <>
      (2) Based on a 4-week use test of 72 subjects aged from 25 to 70 years old with sensitive skin
      who tested Prose serum twice a day (somewhat agree to strongly agree).
      <br />
      <br />
    </>,
    <>
      (3) Based on a 4-week use test of 72 subjects aged from 25 to 70 years old with sensitive skin
      that tested Prose medium moisturizer twice a day (somewhat agree to strongly agree).
      <br />
      <br />
    </>,
  ],
};
